export default "__VITE_ASSET__jFJZ6xo4__"